// Stub for @nestjs/swagger decorators
export const ApiProperty = () => () => {}
export const ApiPropertyOptional = () => () => {}
export const ApiResponse = () => () => {}
export const ApiTags = () => () => {}
export const ApiOperation = () => () => {}
export const ApiBearerAuth = () => () => {}
export const ApiBody = () => () => {}
export const ApiParam = () => () => {}
export const ApiQuery = () => () => {}
export const ApiHeader = () => () => {}
export const ApiExcludeEndpoint = () => () => {}
export const ApiExcludeController = () => () => {}
export const ApiHideProperty = () => () => {}
export const ApiExtraModels = () => () => {}
export const ApiOkResponse = () => () => {}
export const ApiCreatedResponse = () => () => {}
export const ApiAcceptedResponse = () => () => {}
export const ApiNoContentResponse = () => () => {}
export const ApiMovedPermanentlyResponse = () => () => {}
export const ApiFoundResponse = () => () => {}
export const ApiBadRequestResponse = () => () => {}
export const ApiUnauthorizedResponse = () => () => {}
export const ApiForbiddenResponse = () => () => {}
export const ApiNotFoundResponse = () => () => {}
export const ApiMethodNotAllowedResponse = () => () => {}
export const ApiNotAcceptableResponse = () => () => {}
export const ApiRequestTimeoutResponse = () => () => {}
export const ApiConflictResponse = () => () => {}
export const ApiGoneResponse = () => () => {}
export const ApiPayloadTooLargeResponse = () => () => {}
export const ApiUnsupportedMediaTypeResponse = () => () => {}
export const ApiUnprocessableEntityResponse = () => () => {}
export const ApiInternalServerErrorResponse = () => () => {}
export const ApiNotImplementedResponse = () => () => {}
export const ApiBadGatewayResponse = () => () => {}
export const ApiServiceUnavailableResponse = () => () => {}
export const ApiGatewayTimeoutResponse = () => () => {}
export const ApiDefaultResponse = () => () => {}
